import React, { useEffect, useRef, useState, useContext } from 'react';
import query from 'jquery';
import { Link, NavLink, useNavigate, useSearchParams, useLocation } from 'react-router-dom';

import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Swal from 'sweetalert2';

import JWTContext from '../../context/JWTContext';
import axios from '../../utils/axios';
import { useGoogleLogin } from '@react-oauth/google';

const baseSellerUrl = process.env.REACT_APP_SELLER_URL || 'http://localhost:3010/';

const schema = yup
    .object({
        email: yup.string().email().required(),
    })
    .required();

const ForgotPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const redirectPath = params.get('redirect') || '/';

    const [isLoading, setIsLoading] = useState(false);

    const { forgotPassword } = useContext(JWTContext);

    const inputClass = (field) => `form-control border-0 border-bottom p-10 text-14 ${errors[field] ? 'is-invalid' : ''}`;

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        setIsLoading(true);
        try {
            const result = await forgotPassword(data.email);

            console.log('Forgot password result:', result);

            Swal.fire({
                title: 'Success',
                text: 'A password reset link has been sent to your email address.',
                icon: 'success'
            }).then(() => {
                navigate('/admin/login');
            });
    //   navigate('/reset-password');
        } catch (err) {
            //console.log(err);
            Swal.fire({
                title: 'Error',
                text: err,
                icon: 'error'
            });
        }
        setIsLoading(false);
    };

    return (
        <>
            <section
                className="banner-form text_inter position-relative"
                style={{ backgroundImage: "url('/assets/images/profile_temp/bgheader.jpg')", height: '100vh' }}
            >
                <div className="bgHalf"></div>
                <div className="container h-100 z-3 position-relative">
                    <div className="row align-items-center justify-content-center h-100">
                        <div className="col-12 col-md-6 formstyle">
                            <span className="fw-bold text-36 text-white text-center d-block mx-auto text_quicksand">
                                Forgot Password
                            </span>
                            <div className="p-20 px-0 ps-md-32 pe-md-0">
                                <div className="bg-white p-20 text_quicksand  mx-auto" style={{ borderRadius: '6px', maxWidth: '480px' }}>
                                    <div className="mt-20">
                                        <span className="text-14 text-center lh_24">
                                            {' '}
                                            Please enter your email address and we will send you a link to reset your password.
                                        </span>
                                    </div>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="form-group mb-24">
                                            <input
                                                type="text"
                                                className={inputClass('email')}
                                                placeholder="Enter Email Address"
                                                {...register('email')}
                                            />
                                            {errors.email && <small className="text-danger">{errors.email.message}</small>}
                                        </div>
                                        <button className="btn btn_register font-14 fw-bold text_quicksand" type="submit" disabled={isLoading}>
                                            {isLoading ? 'Sending...' : 'Send Reset Link'}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ForgotPassword;
